module.exports = __webpack_public_path__ + "img/logo_discovery.be552a45.svg";